import moment from 'moment-timezone';
import getHourlyIntervalFormat from '@utils/getHourlyIntervalFormat';
import { Interval } from '../types';

const format = {
  short: 'HH:mm',
  long: 'MMM DD YYYY HH:mm',
  withSeconds: 'HH:mm:ss'
};

// eslint-disable-next-line import/prefer-default-export
export const formatInterval = (interval: Interval, liveMode: boolean): string => {
  const { from, to } = interval;
  let startInterval = moment(from);
  let endInterval = moment(to);
  if (moment().diff(startInterval, 'days') > 31) {
    const { start, end } = getHourlyIntervalFormat(startInterval, endInterval);
    startInterval = start;
    endInterval = end;
  }

  if(liveMode){
    return `${startInterval.format(format.withSeconds)} - ${endInterval.format(format.withSeconds)}`;
  }

  if (startInterval.isSame(endInterval, 'day')) {
    return `${startInterval.format(format.long)} - ${endInterval.format(format.short)}`;
  }
  return `${startInterval.format(format.long)} - ${endInterval.format(format.long)}`;
};
